import { render, staticRenderFns } from "./SalaryEffectDelete.vue?vue&type=template&id=be3737c6&scoped=true&"
import script from "./SalaryEffectDelete.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3737c6",
  null
  
)

export default component.exports